var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "audience" },
    [
      _c(
        "v-expansion-panel",
        {
          attrs: { expand: "" },
          model: {
            value: _vm.panel,
            callback: function($$v) {
              _vm.panel = $$v
            },
            expression: "panel"
          }
        },
        [
          _c(
            "v-expansion-panel-content",
            [
              _c(
                "div",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("v-icon", { staticClass: "mr-2 primary--text" }, [
                    _vm._v("bar_chart")
                  ]),
                  _vm._v(_vm._s(_vm.$t("statSuperv1")))
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", md4: "" } },
                        [
                          _vm.loadingAgentsChats
                            ? _c(
                                "v-card",
                                {
                                  staticClass: "mb-3",
                                  attrs: { height: "360px" }
                                },
                                [
                                  _c(
                                    "v-card-text",
                                    { staticClass: "text-xs-center pt-5" },
                                    [
                                      _c("v-progress-circular", {
                                        staticClass: "primary--text",
                                        attrs: { indeterminate: "" }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _c(
                                "v-card",
                                {
                                  staticClass: "mb-3 text-md-center",
                                  attrs: { height: "360px" }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "" } },
                                    [
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "primary",
                                            dark: "",
                                            flat: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.exportAgentsChatsPie()
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.$t("statSuperv3")) +
                                              "\n                "
                                          ),
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                color: "primary",
                                                right: ""
                                              }
                                            },
                                            [_vm._v("file_download")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("highcharts", {
                                    attrs: { options: _vm.agentsChatsPie }
                                  })
                                ],
                                1
                              )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", md4: "" } },
                        [
                          _vm.loadingActivity
                            ? _c(
                                "v-card",
                                {
                                  staticClass: "mb-3",
                                  attrs: { height: "360px" }
                                },
                                [
                                  _c(
                                    "v-card-text",
                                    { staticClass: "text-xs-center pt-5" },
                                    [
                                      _c("v-progress-circular", {
                                        staticClass: "primary--text",
                                        attrs: { indeterminate: "" }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _c(
                                "v-card",
                                {
                                  staticClass: "mb-3 text-md-center",
                                  attrs: { height: "360px" }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "" } },
                                    [
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "primary",
                                            dark: "",
                                            flat: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.exportProductivity()
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.$t("statSuperv3")) +
                                              "\n                "
                                          ),
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                color: "primary",
                                                right: ""
                                              }
                                            },
                                            [_vm._v("file_download")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("highcharts", {
                                    attrs: {
                                      options: _vm.graphProductivityAgent
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("connectionRate")) +
                                        " : " +
                                        _vm._s(_vm.tauxProductivity1) +
                                        " % (" +
                                        _vm._s(_vm.afficheTotalTempsConnexion) +
                                        ")"
                                    )
                                  ]),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("agentsActivity")) +
                                        " : " +
                                        _vm._s(_vm.tauxProductivity2) +
                                        " % (" +
                                        _vm._s(_vm.afficheTotalTempsPresence) +
                                        ")"
                                    )
                                  ]),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("agentsInactivity")) +
                                        " : " +
                                        _vm._s(_vm.tauxProductivity3) +
                                        " % (" +
                                        _vm._s(_vm.afficheTotalTempsHorsProd) +
                                        ")"
                                    )
                                  ]),
                                  _c("br")
                                ],
                                1
                              )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", md4: "" } },
                        [
                          _vm.loadingActivity
                            ? _c(
                                "v-card",
                                {
                                  staticClass: "mb-3",
                                  attrs: { height: "360px" }
                                },
                                [
                                  _c(
                                    "v-card-text",
                                    { staticClass: "text-xs-center pt-5" },
                                    [
                                      _c("v-progress-circular", {
                                        staticClass: "primary--text",
                                        attrs: { indeterminate: "" }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _c(
                                "v-card",
                                {
                                  staticClass: "mb-3 text-md-center",
                                  attrs: { height: "360px" }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "" } },
                                    [
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "primary",
                                            dark: "",
                                            flat: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.exportAgentsOccupation()
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.$t("statSuperv3")) +
                                              "\n                "
                                          ),
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                color: "primary",
                                                right: ""
                                              }
                                            },
                                            [_vm._v("file_download")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("highcharts", {
                                    attrs: { options: _vm.activityAgent }
                                  })
                                ],
                                1
                              )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-expansion-panel-content",
            [
              _c(
                "div",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("v-icon", { staticClass: "mr-2 primary--text" }, [
                    _vm._v("bar_chart")
                  ]),
                  _vm._v(_vm._s(_vm.$t("statSuperv4")))
                ],
                1
              ),
              _vm._v(" "),
              _vm.loadingActivity
                ? _c(
                    "v-card",
                    { staticClass: "mb-3", attrs: { height: "360px" } },
                    [
                      _c(
                        "v-card-text",
                        { staticClass: "text-xs-center pt-5" },
                        [
                          _c("v-progress-circular", {
                            staticClass: "primary--text",
                            attrs: { indeterminate: "" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _c(
                    "v-card",
                    {
                      staticClass: "mb-3 text-md-center",
                      attrs: { height: "360px" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "primary", dark: "", flat: "" },
                              on: {
                                click: function($event) {
                                  return _vm.exportStatut()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("statSuperv3")) +
                                  "\n            "
                              ),
                              _c(
                                "v-icon",
                                { attrs: { color: "primary", right: "" } },
                                [_vm._v("file_download")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("highcharts", {
                        attrs: { options: _vm.tauxActivityAgent }
                      })
                    ],
                    1
                  )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-expansion-panel-content",
            [
              _c(
                "div",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("v-icon", { staticClass: "mr-2 primary--text" }, [
                    _vm._v("bar_chart")
                  ]),
                  _vm._v(_vm._s(_vm.$t("statSuperv5")))
                ],
                1
              ),
              _vm._v(" "),
              _vm.loadingAgentsChats
                ? _c(
                    "v-card",
                    { staticClass: "mb-3", attrs: { height: "360px" } },
                    [
                      _c(
                        "v-card-text",
                        { staticClass: "text-xs-center pt-5" },
                        [
                          _c("v-progress-circular", {
                            staticClass: "primary--text",
                            attrs: { indeterminate: "" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _c(
                    "v-card",
                    {
                      staticClass: "mb-3 text-md-center",
                      attrs: { height: "360px" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "primary", dark: "", flat: "" },
                              on: {
                                click: function($event) {
                                  return _vm.exportAgentsChatsBar()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("statSuperv3")) +
                                  "\n            "
                              ),
                              _c(
                                "v-icon",
                                { attrs: { color: "primary", right: "" } },
                                [_vm._v("file_download")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("highcharts", {
                        attrs: { options: _vm.agentsChatsBar }
                      })
                    ],
                    1
                  )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-expansion-panel-content",
            [
              _c(
                "div",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("v-icon", { staticClass: "mr-2 primary--text" }, [
                    _vm._v("bar_chart")
                  ]),
                  _vm._v(_vm._s(_vm.$t("statSuperv6")))
                ],
                1
              ),
              _vm._v(" "),
              _vm.loadingAgentsPresence
                ? _c(
                    "v-card",
                    { attrs: { height: "360px" } },
                    [
                      _c(
                        "v-card-text",
                        { staticClass: "text-xs-center pt-5" },
                        [
                          _c("v-progress-circular", {
                            staticClass: "primary--text",
                            attrs: { indeterminate: "" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _c(
                    "v-card",
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [_c("v-spacer")],
                        1
                      ),
                      _vm._v(" "),
                      _c("highcharts", {
                        attrs: { options: _vm.agentsPresence }
                      })
                    ],
                    1
                  )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          ref: "dialogOccupation",
          attrs: {
            persistent: "",
            "max-width": "1200px",
            scrollable: !_vm.$vuetify.breakpoint.smAndDown,
            fullscreen: _vm.$vuetify.breakpoint.smAndDown
          },
          model: {
            value: _vm.occupationAgentDay,
            callback: function($$v) {
              _vm.occupationAgentDay = $$v
            },
            expression: "occupationAgentDay"
          }
        },
        [
          _vm.occupationAgentDay
            ? _c("wz-agents-occupation-day", {
                attrs: { dataAgentSelected: _vm.dataAgentSelected },
                on: { closeDialog: _vm.dialogOccupationRemove }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          ref: "dialogOccupation",
          attrs: {
            persistent: "",
            "max-width": "1200px",
            scrollable: !_vm.$vuetify.breakpoint.smAndDown,
            fullscreen: _vm.$vuetify.breakpoint.smAndDown
          },
          model: {
            value: _vm.occupationAgentPeriode,
            callback: function($$v) {
              _vm.occupationAgentPeriode = $$v
            },
            expression: "occupationAgentPeriode"
          }
        },
        [
          _vm.occupationAgentPeriode
            ? _c("wz-agents-occupation-periode", {
                attrs: { dataAgentSelected: _vm.dataAgentSelected },
                on: { closeDialog: _vm.dialogOccupationPeriodeRemove }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          ref: "dialogPresence",
          attrs: {
            persistent: "",
            "max-width": "1200px",
            scrollable: !_vm.$vuetify.breakpoint.smAndDown,
            fullscreen: _vm.$vuetify.breakpoint.smAndDown
          },
          model: {
            value: _vm.presenceAgentsDay,
            callback: function($$v) {
              _vm.presenceAgentsDay = $$v
            },
            expression: "presenceAgentsDay"
          }
        },
        [
          _vm.presenceAgentsDay
            ? _c("wz-agents-presence-day", {
                attrs: { dataAgentsSelected: _vm.dataAgentsSelected },
                on: { closeDialog: _vm.dialogPresenceDayRemove }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ab59165c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab59165c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats/AgentsPerformance.vue
// module id = null
// module chunks = 